    /* Package JSON Import will be here */
    import React, { Component, Fragment } from 'react';
    import { connect } from 'react-redux';
    import {
        withRouter
    } from 'react-router-dom';
    import ProjectsComponent from "./projects.Components";
    import { MenuItem } from '@material-ui/core';
    import { ApiUrls } from '../../services/api';
    import Api from '../../services/api/serviceCall';
    import { Constants } from '../../config/appConstants';
    import { MessageBox } from '../sharedComponent/messageBox';
    import { bindActionCreators } from 'redux';
    import * as actions from '../../actions/login.Action';
    /* Package JSON Import will be here */
    /* Project Import will be here */


    /* Const,Let & Var will be here */
    /* Const,Let & Var will be here */
    class Projects extends Component {
        constructor(props) {
            super(props);
            this.state = {
                projectsList: [],
                selectedProjectDevices: [],
                selectedProjectTasks: [],
                selectedProjects: {},
                status: [{
                    option: "Active", value: 'active'
                }, {
                    option: "InActive", value: 'inActive',
                }],
                filterProjectData: [],
                selectedStatus: 'active',
                searchProjectText: "",
                isOpenAssignmentModal: false,
                searchDeviceText: "",
                searchUnAssignDeviceText: "",
                searchAssignedDeviceText: "",
                searchTaskText: "",
                isViewProjectDetails: false,
                unAssignedProjectDevice: [],
                pagination: {
                    activePage: 1,
                    totalCount: 0,
                    skip: Constants.DEFAULT_SKIP,
                    take: Constants.DEFAULT_TAKE
                },
                selectedDevices: [],
                projectBasedAssignedDevices: [],
                selectedAssignedDevices: [],
                isSelectAllForDevices: false,
                isSelectAllForAssignedDevice: false,
                projectStatusOptions: [
                    { key: 'Active', text: 'Active', value: 'active' },
                    { key: 'Active', text: 'InActive', value: 'inactive' }
                ],

                selectedAssignedProjectDevices: [],

                assignedDevicesForProject: [],
                isSaveBtnDisabled: false,
                
                //for infinite scroll
                assignedProjectCurrentTake: Constants.DEFAULT_TAKE,  
                unAssignedProjectCurrentTake: Constants.DEFAULT_TAKE,  
                assignedProjectDeviceInfiniteList: [],  
                unAssignedProjectDeviceInfiniteList: [],  
                isSelectAllUnAssignedProjectDevice: false,
                isSelectAllAssignedProjectDevice: false,
                unAssignedClonedDevicesList:[],

            };
            this.deviceNameSearchDebounce = null;
            this.taskCodeSearchDebounce = null;
            this.assignDeviceSearchDebounce = null;
            this.unAssignDeviceSearchDebounce = null;
            this.projectSearchDebounce = null;
            this.originalAssignedDeviceIds = [];
        };

        async componentDidMount() {
            this.getProjectsDetailsList();
            await this.getAllDevice();
        }

        componentWillUnmount(){
            clearTimeout(this?.projectSearchDebounce);
            clearTimeout(this?.unAssignDeviceSearchDebounce);
            clearTimeout(this?.assignDeviceSearchDebounce);
            clearTimeout(this?.taskCodeSearchDebounce);
            clearTimeout(this?.deviceNameSearchDebounce);
        }

        handleGcChange(e, { value }) {
            let { selectedProjects } = this.state;
            selectedProjects.gc = value;
            this.setState({
                selectedProjects
            })
        }

        //Unassigned Devices Col
        handleChkBoxChgForUnassignedDevices(e, { value }) {
            this.setState({
                isSelectAllForDevices: value.checked
            }, () => {
                this.assignMultipleDevicesToProject(this.state.isSelectAllForDevices);
            });
        }

        handleChgChkBoxForUnassignedDevice(e, { value }, deviceID) {
            this.assignDeviceToProjects({ isSelected: value.checked, deviceID: deviceID });
        }

        assignMultipleDevicesToProject = (isAllSelected) => {
            let { unAssignedProjectDevice, selectedDevices,unAssignedProjectDeviceInfiniteList,isSelectAllUnAssignedProjectDevice,searchUnAssignDeviceText } = this.state;
            if (unAssignedProjectDevice) {
                let unAssignedDevices = JSON.parse(JSON.stringify(unAssignedProjectDevice));
                const unAssignDeviceSearchText = searchUnAssignDeviceText?.toLowerCase().split(" ");

                //for checkbox select all with search 
                if (searchUnAssignDeviceText) {
                    unAssignedDevices = unAssignedDevices.map(data =>
                        unAssignDeviceSearchText.every(w => data.deviceEmpID.toLowerCase().includes(w))
                            ? { ...data, isSelected: isAllSelected, isCheckedChckBox: isAllSelected }
                            : data);
                }
                else {
                    unAssignedDevices.map((data) => {
                        data['isSelected'] = isAllSelected;
                        data['isCheckedChckBox'] = isAllSelected;
                    });
                }

                //for infinite scroll list
                unAssignedProjectDeviceInfiniteList.length > 0 && unAssignedProjectDeviceInfiniteList.map(a => {
                    a.isSelected = isAllSelected;
                    a.isCheckedChckBox = isAllSelected;
                });
                
                isSelectAllUnAssignedProjectDevice = isAllSelected && unAssignedProjectDeviceInfiniteList.length > 0 && unAssignedProjectDeviceInfiniteList.every(a => a.isSelected && a.isCheckedChckBox);

                selectedDevices = isAllSelected && unAssignedProjectDevice.length > 0
                    ? [...unAssignedDevices.filter(a => a.isSelected && unAssignDeviceSearchText?.every(w => a.deviceEmpID.toLowerCase().includes(w))),
                    ...selectedDevices.filter(a => unAssignedProjectDevice.every(b => a.deviceEmpID !== b.deviceEmpID))] : [];
                this.setState({ unAssignedProjectDevice: unAssignedDevices, selectedDevices: selectedDevices,unAssignedProjectDeviceInfiniteList,isSelectAllUnAssignedProjectDevice });
            }
        }

        //Assigned Devices Col
        handleChkBoxChgForAssignedDevices(e, { value }) {
            this.setState({
                isSelectAllForAssignedDevice: value.checked
            }, () => {
                this.unassignMultipleDevicesToProject(this.state.isSelectAllForAssignedDevice);
            });
        }

        handleChgChkBoxForAssignedDevice(e, { value }, deviceID) {        
            this.assignDeviceToProjects({ deviceID: deviceID });
        }

        unassignMultipleDevicesToProject = (isAllSelected) => {
            let { selectedAssignedDevices, selectedAssignedProjectDevices,assignedProjectDeviceInfiniteList,isSelectAllAssignedProjectDevice,searchAssignedDeviceText } = this.state;
            if (selectedAssignedProjectDevices) {
                let assignedDevices = JSON.parse(JSON.stringify(selectedAssignedProjectDevices));
            
                //for checkbox select all with search 
                if (searchAssignedDeviceText) {
                    const assignDeviceSearchText = searchAssignedDeviceText.toLowerCase().split(" ");
                    assignedDevices = assignedDevices.map(data =>
                        assignDeviceSearchText.every(w => data.deviceEmpID.toLowerCase().includes(w))
                            ? { ...data, isSelected: isAllSelected, isCheckedChckBox: isAllSelected }
                            : data
                    );
                } else {
                    assignedDevices.map((data) => {
                        data['isSelected'] = isAllSelected;
                        data['isCheckedChckBox'] = isAllSelected;
                    });
                }

                //for infinite scroll list
                assignedProjectDeviceInfiniteList.map((data)=>{
                    data.isSelected = isAllSelected;
                    data.isCheckedChckBox = isAllSelected;
                })

                isSelectAllAssignedProjectDevice = isAllSelected && assignedProjectDeviceInfiniteList.length > 0 && assignedProjectDeviceInfiniteList.every(a => a.isSelected && a.isCheckedChckBox);

                selectedAssignedDevices = isAllSelected && selectedAssignedProjectDevices.length > 0 ?
                    [...assignedDevices, ...selectedAssignedDevices.filter(a => selectedAssignedProjectDevices.every(b => a.deviceEmpID !== b.deviceEmpID))] : [];

                this.setState({ selectedProjectDevices: assignedDevices, selectedAssignedDevices, selectedAssignedProjectDevices: assignedDevices,assignedProjectDeviceInfiniteList,isSelectAllAssignedProjectDevice });
            }
        }

        getProjectsDetailsList() {
            let { searchProjectText, pagination } = this.state;
            let searchArray = [];

            if (searchProjectText) {
                var searchTextSplit = searchProjectText.split('-');
                if (searchTextSplit.length > 1) {
                    searchProjectText = `${searchTextSplit[0].trim()}-${searchTextSplit[1].trim()}`;
                }
                let searchObj = {
                    FieldName: Constants.PROJECT_NAME,
                    Value: searchProjectText
                };
                searchArray.push(searchObj);
            };
            searchArray.push({
                FieldName: Constants.USER_ID,
                value: this.props.user.userId.toString()
            });
            let requestData = {
                SearchText: searchArray,
                Skip: pagination.skip,
                Take: pagination.take,
                Status: this.state.selectedStatus
            }
            let url = `${ApiUrls.Routes.PJT_C}${ApiUrls.Routes.GT_PJT_LT_M}`;
            Api.Post(url, requestData, this).then((responseData) => {
                if (responseData) {
                    if (responseData.success) {
                        pagination.totalCount = Math.ceil(responseData.totalCount / Constants.DEFAULT_TAKE);
                        this.setState({
                            projectsList: responseData.data,
                            pagination
                        });
                        this.filterdata();
                    }
                    else {
                        this.setState({
                            projectsList: []
                        });
                    }
                }
            });
        }

        getProjectTaskAndDevice(projectId, projectNumber = null, isForEdit = false) {
            let { searchDeviceText, searchTaskText } = this.state;
            let searchArray = [];
            if (searchDeviceText) {
                let searchObj = {
                    FieldName: Constants.PROJECT_DEVICE_NAME,
                    Value: searchDeviceText
                };
                searchArray.push(searchObj);
            };
            if (searchTaskText) {
                let searchObj = {
                    FieldName: Constants.PROJECT_TASK_NAME,
                    Value: searchTaskText
                };
                searchArray.push(searchObj);
            };
            searchArray.push({
                FieldName: Constants.USER_ID,
                value: this.props.user.userId.toString()
            });
            let requestData = {
                SearchText: searchArray
            }
            if (projectId) {
                let url = `${ApiUrls.Routes.PJT_C}${ApiUrls.Routes.GT_PJT_TSK_DEVCE_M}?projectId=${projectId}&&projectNumber=${projectNumber}`;
                Api.Post(url, requestData, this).then((responseData) => {
                    if (responseData) {
                        if (responseData.success) {

                            if (!searchDeviceText) {
                                this.setState({
                                    assignedDevicesForProject: responseData.data.device,

                                });
                            }

                            this.setState({
                                projectBasedAssignedDevices: responseData.data.device,
                                selectedProjectTasks: responseData.data.task,
                                });
                        }
                        else {
                            this.setState({
                                projectBasedAssignedDevices: [],
                                selectedProjectTasks: [],
                                assignedDevicesForProject: []
                            });
                        }
                    }
                });
            }
        }

    async getAllDevice() {
            let searchArray = [];
            searchArray.push({
                FieldName: Constants.USER_ID,
                value: this.props.user.userId.toString()
            });
            let requestData = {
                SearchText: searchArray,
                Status: Constants.PROJECT_STATUS_ACTIVE
            }
            let url = `${ApiUrls.Routes.DEVCE_C}${ApiUrls.Routes.GT_A_DEVCE_M}`;
            return Api.Post(url, requestData, this).then((responseData) => {
                return new Promise(resolve => {
                    if (responseData.success && responseData.data.length > 0) {
                        this.setState({
                            unAssignedProjectDevice: [...responseData.data],
                            unAssignedClonedDevicesList: [...responseData.data]
                        }, () => resolve(responseData));
                    } else {
                        resolve(responseData);
                    }
                });
            });
        }

        filterdata() {
            let filterApplied = [];
            filterApplied = this.state.projectsList;
            if (filterApplied && filterApplied.length > 0) {
                filterApplied[0]['isSelected'] = true;
                let projectId = filterApplied[0].id;
                let projectNumber = filterApplied[0].projectNumber;
                this.getProjectTaskAndDevice(projectId, projectNumber);
            }
            else {
                this.setState({
                    projectBasedAssignedDevices: [],
                    selectedProjectTasks: []
                });
            }
            this.setState({ filterProjectData: filterApplied });
        }

        handleChange = event => {
            this.setState({
                selectedStatus: event.target.value,
                option: event.target.name,
                pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 },
                searchProjectText: "",
                searchDeviceText: "",
                searchUnAssignDeviceText: "",
                searchAssignedDeviceText: "",
                searchTaskText: ""
            }, () => {
                this.getProjectsDetailsList();
            });
        };

    onProjectSearch = event => {
            this.setState({ searchProjectText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            clearTimeout(this.projectSearchDebounce);
            this.projectSearchDebounce = setTimeout(() => {
                this.getProjectsDetailsList();
            },1000);
                
            });
        }

        onProjectDeviceSearch = event => {
            this.setState({ searchDeviceText: event.target.value }, () => {
                let project = this.state.filterProjectData.find(a => a.isSelected);
                if (project && project.id) {
                    clearTimeout(this.deviceNameSearchDebounce);
                    this.deviceNameSearchDebounce = setTimeout(() => {
                        this.getProjectTaskAndDevice(project.id, project.projectNumber);
                    }, 1000);
                }
            });
        }

        onProjectTaskSearch = event => {
            this.setState({ searchTaskText: event.target.value }, () => {
                let project = this.state.filterProjectData.find(a => a.isSelected);
                clearTimeout(this.taskCodeSearchDebounce);
                if (project && project.id) {
                    this.taskCodeSearchDebounce = setTimeout(() => {
                    this.getProjectTaskAndDevice(project.id, project.projectNumber);
                }, 1000);
                }
            });
        }

        onUnAssignDeviceSearch = event => {
            this.setState({ searchUnAssignDeviceText: event.target.value }, () => {
                clearTimeout(this.unAssignDeviceSearchDebounce);
                this.unAssignDeviceSearchDebounce = setTimeout(() => {
                    this.searchAndFilterUnAssignedProject();
                }, 1000);
            });
        }

        onAssignedDeviceSearch = event => {
            this.setState({ searchAssignedDeviceText: event.target.value }, () => {
                clearTimeout(this.assignDeviceSearchDebounce);
                this.assignDeviceSearchDebounce = setTimeout(() => {
                    this.searchAndFilterAssignedProject();
                }, 1000);   
            });
        }

    async filterAssignedDevices() {
            let { selectedProjects,unAssignedClonedDevicesList } = this.state;
            let searchArray = [];
            searchArray.push({
                FieldName: Constants.USER_ID,
                value: this.props.user.userId.toString()
            });
            let requestData = {
                SearchText: searchArray,
                Status: Constants.PROJECT_STATUS_ACTIVE
            }
            let projectID = selectedProjects.id;
            let projectNumber = selectedProjects.projectNumber;
            let url = `${ApiUrls.Routes.PJT_C}${ApiUrls.Routes.GT_PJT_TSK_DEVCE_M}?projectId=${projectID}&&projectNumber=${projectNumber}`
            Api.Post(url, requestData, this).then((responseData) => {
                if (responseData && responseData.success) {
                    if (responseData.data && responseData.data.device && responseData.data.device.length > 0) {
                        let assignedProjectDevices = [...responseData.data.device];
                        this.originalAssignedDeviceIds = assignedProjectDevices.map(d => d.deviceID);

                        // For unassigned device list filter
                        let unAssignedProjectDevices = [];
                        let { selectedProjectDevices } = this.state;

                        let unAssignedProjectDeviceslist = JSON.parse(JSON.stringify(unAssignedClonedDevicesList));
                        unAssignedProjectDeviceslist.forEach(data => {
                            if ((assignedProjectDevices.length > 0 && !responseData.data.device.find(a => a.deviceID === data.deviceID) && !selectedProjectDevices.find(a => a.deviceID === data.deviceID))) {
                                unAssignedProjectDevices.push(data);
                            }
                        });
                        this.setState({
                            selectedProjectDevices: assignedProjectDevices,
                            selectedAssignedProjectDevices: assignedProjectDevices,
                            // isOpenAssignmentModal: true,
                            unAssignedProjectDevice: unAssignedProjectDevices
                        }, () => {
                            this.searchAndFilterUnAssignedProject();
                            this.searchAndFilterAssignedProject();
                        });

                    } else {
                        this.originalAssignedDeviceIds = [];
                        this.setState({ selectedAssignedProjectDevices: [], unAssignedProjectDevice: JSON.parse(JSON.stringify(unAssignedClonedDevicesList)) }, () => {
                            this.searchAndFilterUnAssignedProject();
                            this.searchAndFilterAssignedProject();
                        });
                    }
                }
            });
        }

        renderOptions() {
            return this.state.status.map((data, i) => {
                return (
                    <MenuItem
                        label="Status"
                        value={data.value}
                        key={i} option={data.option}>{data.option}</MenuItem>

                );
            });
        }
        onPageChange = (e, { activePage }) => {
            let { pagination } = this.state;
            pagination.skip = ((activePage - 1) * Constants.DEFAULT_TAKE) + 1;
            pagination.take = ((activePage - 1) * Constants.DEFAULT_TAKE) + Constants.DEFAULT_TAKE;
            pagination.activePage = activePage;
            this.setState({
                pagination
            }, () => {
                this.getProjectsDetailsList();
            });
        }

        selectedProject = (projectId, projectNumber, isEdit = false) => {
            this.state.projectsList.map((projectData) => {
                if (projectData.id === projectId) {
                    projectData['isSelected'] = true;
                }
                else {
                    projectData['isSelected'] = false;
                }
            });
            this.getProjectTaskAndDevice(projectId, projectNumber, isEdit);
            this.setState({ projectsList: this.state.projectsList }, () => {
                if (isEdit) {
                    this.editAssignDevices({ modalOpen: true, projectId: projectId });
                }
            });
        }

        editAssignDevices = async (editAssignDevice) => {
            if (editAssignDevice.modalOpen) {
                let selectedProject = this.state.projectsList.find(a => a.id == editAssignDevice.projectId);
                this.setState({ selectedProjects: selectedProject, unAssignedProjectDevice: [], selectedAssignedProjectDevices: [], selectedProjectDevices: [], isOpenAssignmentModal: true }, async () => {
                    if (this.state.unAssignedClonedDevicesList.length === 0) {
                        await this.getAllDevice();
                    }
                    await this.filterAssignedDevices(true);
                    //await this.getAllDevice();
                });
            }
            else {
                this.setState({
                    searchUnAssignDeviceText: "",
                    searchAssignedDeviceText: "",
                    isOpenAssignmentModal: false,
                    isSelectAllForDevices: false,
                    isSelectAllForAssignedDevice: false,
                    selectedDevices: [],
                    selectedAssignedDevices: [],
                    selectedAssignedProjectDevices: [],
                    assignedDevicesForProject: [],
                    unAssignedProjectDevice:[],
                    isSaveBtnDisabled: false
                },
                    () => {
                        this.originalAssignedDeviceIds = [];
                        let project = this.state.filterProjectData.find(a => a.isSelected);
                        this.resetAll();
                        this.getProjectTaskAndDevice(project.id, project.projectNumber);
                    });
            }
        }

        saveAssignOrUnassignProjectDevices = () => {
            this.setState({ isSaveBtnDisabled: true },()=>{
            let projectId = this.state.selectedProjects.id;
            let { selectedProjectDevices, searchAssignedDeviceText, assignedDevicesForProject } = this.state;
                if (searchAssignedDeviceText) {
                    selectedProjectDevices.map(t => {
                        var deviceAlreadyExist = assignedDevicesForProject.find(d => d.deviceID === t.deviceID);
                        if (deviceAlreadyExist === undefined) {
                            assignedDevicesForProject.push(t);
                        }
                    })
                    selectedProjectDevices = assignedDevicesForProject;
                }

                let devices = [];
                const deletedAssignedDevices = this.originalAssignedDeviceIds
                    .filter(id => !selectedProjectDevices.find(d => d.deviceID === id));

                const newlyAssignedDevices = selectedProjectDevices
                    .filter(d => !this.originalAssignedDeviceIds.find(id => id === d.deviceID));

                deletedAssignedDevices.forEach(id =>
                    devices.push({ deviceId: id, status: "deleted" })
                );

                newlyAssignedDevices.forEach(d =>
                    devices.push({ deviceId: d.deviceID, status: "new" })
                );  

            if (selectedProjectDevices.length > 0 || searchAssignedDeviceText === "") {
                let url = `${ApiUrls.Routes.PJT_C}${ApiUrls.Routes.UT_PJTDEVCE_M}?projectId=${projectId}&&modifiedById=${this.props.user.userId}`;
                Api.Post(url, devices, this).then((responseData) => {
                    if (responseData) {
                        if (responseData.success) {
                            let project = this.state.filterProjectData.find(a => a.isSelected);
                            this.setState({
                                searchUnAssignDeviceText: "",
                                searchAssignedDeviceText: "",
                                isOpenAssignmentModal: false,
                                selectedDevices: [],
                                selectedAssignedDevices: [],
                                selectedProjectDevices: [],
                                assignedDevicesForProject: [],
                                isSaveBtnDisabled: false,
                            }, function () {
                                this.getProjectTaskAndDevice(project.id, project.projectNumber);
                            });
                        }
                        MessageBox(responseData.message, responseData.success ? Constants.SUCCESS : Constants.ERROR);
                    }
                });
            } else {
                let project = this.state.filterProjectData.find(a => a.isSelected);
                this.getProjectTaskAndDevice(project.id, project.projectNumber);
                this.setState({ searchUnAssignDeviceText: "", isOpenAssignmentModal: false,isSaveBtnDisabled:false });
            }
        });
        }

        assignDeviceToProjects = assignDeviceToProject => {
            let { selectedDevices, selectedAssignedDevices, assignedProjectDeviceInfiniteList, isSelectAllUnAssignedProjectDevice, isSelectAllAssignedProjectDevice,searchAssignedDeviceText,searchUnAssignDeviceText} = this.state;
            if (this.state.unAssignedProjectDevice && this.state.selectedAssignedProjectDevices) {
                let unAssignedDevices = JSON.parse(JSON.stringify(this.state.unAssignedProjectDevice));
                let assignedDevices = JSON.parse(JSON.stringify(this.state.selectedAssignedProjectDevices));
                unAssignedDevices.filter((data) => {
                    if (data.deviceID === assignDeviceToProject.deviceID) {
                        data['isSelected'] = !data['isSelected'];
                        data['isCheckedChckBox'] = !data['isCheckedChckBox'];
                        let selectedDeviceIndex = selectedDevices.findIndex(a => a.deviceID === data.deviceID);
                        if (data['isSelected']) {
                            selectedDeviceIndex < 0 && selectedDevices.push(data);
                        }
                        else {
                            selectedDeviceIndex >= 0 && selectedDevices.splice(selectedDeviceIndex, 1);
                        }
                    }
                });

                //for infinite scroll list
                let unAssignedProjectDeviceForInfiniteScroll = JSON.parse(JSON.stringify(this.state.unAssignedProjectDeviceInfiniteList));
                const unAssignDevicesearchText = searchUnAssignDeviceText.toLowerCase().split(" ");

                let filterUnAssignedProjectDevice = unAssignedDevices.length > 0 && unAssignedDevices
                ?.filter(a => unAssignDevicesearchText.every(v => a.deviceEmpID.toLowerCase().includes(v)));
                
                isSelectAllUnAssignedProjectDevice = filterUnAssignedProjectDevice.length > 0 && filterUnAssignedProjectDevice
                ?.every(a => a.isSelected && a.isCheckedChckBox);  //Select all flag for UnAssignDevice Checkbox 

                unAssignedProjectDeviceForInfiniteScroll.filter((data) => {
                    if (data.deviceID === assignDeviceToProject.deviceID) {
                        data.isSelected = !data.isSelected;
                        data.isCheckedChckBox = !data.isCheckedChckBox;
                    }
                });

                assignedDevices.filter((data) => {
                    if (data.deviceID === assignDeviceToProject.deviceID) {
                        data['isSelected'] = !data['isSelected'];
                        data['isCheckedChckBox'] = !data['isCheckedChckBox'];
                        let selectedAssignedDeviceIndex = selectedAssignedDevices.findIndex(a => a.deviceID === data.deviceID);
                        if (data['isSelected']) {
                            selectedAssignedDeviceIndex < 0 && selectedAssignedDevices.push(data);
                        }
                        else {
                            selectedAssignedDeviceIndex >= 0 && selectedAssignedDevices.splice(selectedAssignedDeviceIndex, 1);
                        }
                    }
                })
                
                //for infinite scroll list
                const assignDeviceSearchText = searchAssignedDeviceText?.toLowerCase().split(" ");

                let filterAssignedProjectDevice = assignedDevices.length > 0 && assignedDevices
                ?.filter(a => assignDeviceSearchText.every(v => a.deviceEmpID.toLowerCase().includes(v)));

                isSelectAllAssignedProjectDevice = filterAssignedProjectDevice.length > 0 &&         //Select all flag for AssignDevice Checkbox 
                filterAssignedProjectDevice?.every(a => a.isSelected && a.isCheckedChckBox);

                assignedProjectDeviceInfiniteList.filter((data) => {
                    if (data.deviceID === assignDeviceToProject.deviceID) {
                        data.isSelected = !data.isSelected;
                        data.isCheckedChckBox = !data.isCheckedChckBox;
                    }
                });

                this.setState({ selectedProjectDevices: assignedDevices, selectedAssignedProjectDevices: assignedDevices, unAssignedProjectDevice: unAssignedDevices, selectedDevices, selectedAssignedDevices, unAssignedProjectDeviceInfiniteList: unAssignedProjectDeviceForInfiniteScroll, assignedProjectDeviceInfiniteList, isSelectAllUnAssignedProjectDevice, isSelectAllAssignedProjectDevice });
            }
        }

        assignOrUnassignProjectDevices = assignOrUnassignProjectDevice => {
            let { selectedDevices, isSelectAllForDevices, isSelectAllForAssignedDevice, selectedAssignedDevices,unAssignedProjectDeviceInfiniteList,isSelectAllUnAssignedProjectDevice,assignedProjectDeviceInfiniteList,isSelectAllAssignedProjectDevice,searchAssignedDeviceText,searchUnAssignDeviceText } = this.state;
            if (this.state.unAssignedProjectDevice && this.state.selectedAssignedProjectDevices) {
                let selectedProjectDevicesId = [];
                let unAssignedProjectDevices = JSON.parse(JSON.stringify(this.state.unAssignedProjectDevice));
                let selectedProjectDevices = JSON.parse(JSON.stringify(this.state.selectedAssignedProjectDevices));
                let selectedProjectsForDevice = JSON.parse(JSON.stringify(this.state.assignedDevicesForProject));
                if (assignOrUnassignProjectDevice.isForAssign) {
                    selectedDevices.map((data, index) => {
                        let selectedUnAssignedDeviceIndex = unAssignedProjectDevices.findIndex(a => a.deviceID === data.deviceID);
                        selectedUnAssignedDeviceIndex >= 0 && unAssignedProjectDevices.splice(selectedUnAssignedDeviceIndex, 1);
                        data.isSelected = false;
                        data.isCheckedChckBox = false;
                        selectedProjectDevices.push(data);
                        assignedProjectDeviceInfiniteList.push(data); //for infinite scroll
                        let scrollselectedUnAssignedDeviceIndex = unAssignedProjectDeviceInfiniteList.findIndex(a => a.deviceID === data.deviceID);
                        scrollselectedUnAssignedDeviceIndex >= 0 && unAssignedProjectDeviceInfiniteList.splice(scrollselectedUnAssignedDeviceIndex, 1);
                    });

                    selectedAssignedDevices.map(a => {
                        return selectedDevices.filter(b => {
                            if (a.deviceID === b.deviceID) {
                                a["isSelected"] = false;
                                a["isCheckedChckBox"] = false;
                            }
                        })
                    })

                    const assignDeviceSearchText = searchAssignedDeviceText?.toLowerCase().split(" ");

                    let filterAssignedProjectDevice = selectedProjectDevices
                        ?.filter(a => assignDeviceSearchText.every(v => a.deviceEmpID.toLowerCase().includes(v)));

                    assignedProjectDeviceInfiniteList = filterAssignedProjectDevice //for infinite scroll
                        ?.slice(0, this.state.assignedProjectCurrentTake);

                    const unAssignSearchText = searchUnAssignDeviceText?.toLowerCase().split(" ");
                    unAssignedProjectDeviceInfiniteList = unAssignedProjectDevices 
                        ?.filter(a => unAssignSearchText.every(v => a.deviceEmpID.toLowerCase().includes(v)))
                        ?.slice(0, this.state.unAssignedProjectCurrentTake);

                    selectedDevices = [];
                    isSelectAllForDevices = false;
                    isSelectAllUnAssignedProjectDevice=false;

                    isSelectAllAssignedProjectDevice = filterAssignedProjectDevice.length > 0 && filterAssignedProjectDevice
                        ?.every(a => a.isSelected && a.isCheckedChckBox); //Select All checkbox for assigned device list with search 
                }
                else {

                    var selectedDeviceObj = selectedProjectDevices.filter(t => t.isSelected);
                    var selectedDeviceIds = selectedDeviceObj.map(t => t.deviceID);
                    selectedProjectsForDevice = selectedProjectsForDevice.filter(value => !selectedDeviceIds.includes(value.deviceID));
                    const searchTextAssignDevices = searchAssignedDeviceText?.toLowerCase().split(" ");
                    selectedProjectDevices.map((data, index) => {
                        if (data.isSelected) {
                            assignedProjectDeviceInfiniteList = assignedProjectDeviceInfiniteList.filter(a => a.deviceID != data.deviceID);
                            data.isSelected = false;
                            data.isCheckedChckBox = false;
                            unAssignedProjectDevices.push(data);
                            selectedProjectDevicesId.push(data.deviceID);
                            unAssignedProjectDeviceInfiniteList.push(data); //for infinite scroll

                        }
                    });

                    const unAssignDevicesearchText = searchUnAssignDeviceText.toLowerCase().split(" ");
                    let filterUnAssignedProjectDevice = unAssignedProjectDevices
                        ?.filter(a => unAssignDevicesearchText.every(v => a.deviceEmpID.toLowerCase().includes(v)));

                    unAssignedProjectDeviceInfiniteList = filterUnAssignedProjectDevice
                        ?.slice(0, this.state.unAssignedProjectCurrentTake);    //for infinite scroll

                    isSelectAllForAssignedDevice = false;
                    isSelectAllAssignedProjectDevice = false;

                    isSelectAllUnAssignedProjectDevice = filterUnAssignedProjectDevice.length > 0 && filterUnAssignedProjectDevice
                        ?.every(a => a.isSelected && a.isCheckedChckBox);    //Select All checkbox for unassigned device list with search

                    selectedProjectDevices = selectedProjectDevices.filter((value, i) => !selectedProjectDevicesId.includes(value.deviceID));

                    assignedProjectDeviceInfiniteList = selectedProjectDevices  //for infinite scroll
                        ?.filter(a => searchTextAssignDevices.every(v => a.deviceEmpID.toLowerCase().includes(v)))
                        ?.slice(0, this.state.assignedProjectCurrentTake);

                }
                this.setState({ selectedAssignedDevices, selectedProjectDevices: selectedProjectDevices, assignedDevicesForProject: selectedProjectsForDevice, selectedAssignedProjectDevices: selectedProjectDevices, unAssignedProjectDevice: unAssignedProjectDevices, selectedDevices, isSelectAllForDevices, isSelectAllForAssignedDevice,unAssignedProjectDeviceInfiniteList,isSelectAllUnAssignedProjectDevice,assignedProjectDeviceInfiniteList,isSelectAllAssignedProjectDevice});
            }
        }

        getProjectDetails(projectId, projectNumber = null) {
            let url = `${ApiUrls.Routes.PJT_C}${ApiUrls.Routes.GT_PJT_DTL}?projectId=${projectId}&&projectNumber=${projectNumber}`;
            Api.Get(url, this).then((responseData) => {
                if (responseData) {
                    if (responseData.success) {
                        this.setState({
                            selectedProjects: responseData.data,
                            isViewProjectDetails: true
                        });
                    }
                    else {
                        this.setState({
                            selectedProjects: []
                        });
                    }
                }
            });
        }
        viewProjectDetail = projectDetails => {
            if (projectDetails.projectId) {
                this.getProjectDetails(projectDetails.projectId, projectDetails.projectNumber);
            }
            else {
                this.setState({
                    isViewProjectDetails: projectDetails.modalOpen
                });
            }
        }

        handleFormChange = (e, { value }) => {
            let { selectedProjects } = this.state;
            selectedProjects.projectStatus = value;
            this.setState({ selectedProjects });
        }

        saveProjectDetails() {
            this.setState({ isSaveBtnDisabled: true },()=>{
                let { selectedProjects } = this.state;

            let url = `${ApiUrls.Routes.PJT_C}${ApiUrls.Routes.UPDT_PRJ_DTS}`;
            Api.Post(url, selectedProjects, this).then((responseData) => {
                if (responseData.success) {
                    MessageBox(responseData.message, Constants.SUCCESS);
                    this.getProjectsDetailsList();
                }
                this.setState({
                    isViewProjectDetails: false,
                    isSaveBtnDisabled: false
                });
            });
        });  
        }

        fetchNext(type) {
            switch (type) {
                case "UNASSIGN_DEVICE":
                    if (this.state.unAssignedProjectCurrentTake >= this.state.unAssignedProjectDevice.length) {
                        return;
                    }
                    this.state.unAssignedProjectCurrentTake += Constants.DEFAULT_TAKE;
                    this.searchAndFilterUnAssignedProject();
                    break;
                case "ASSIGN_DEVICE":
                    if (this.state.assignedProjectCurrentTake >= this.state.selectedAssignedProjectDevices.length) {
                        return;
                    }
                    this.state.assignedProjectCurrentTake += Constants.DEFAULT_TAKE;
                    this.searchAndFilterAssignedProject();
                    break;
            }
        }

        searchAndFilterUnAssignedProject() {
            let { unAssignedProjectDevice, unAssignedProjectDeviceInfiniteList, isSelectAllUnAssignedProjectDevice, searchUnAssignDeviceText } = this.state;

            const searchText = searchUnAssignDeviceText.toLowerCase().split(" ");

            const filteredUnAssignedProjectDevices = unAssignedProjectDevice ? unAssignedProjectDevice?.filter(a => searchText.every(v => a.deviceEmpID.toLowerCase().includes(v))) : [];
            unAssignedProjectDeviceInfiniteList = filteredUnAssignedProjectDevices ? filteredUnAssignedProjectDevices
                ?.slice(0, this.state.unAssignedProjectCurrentTake) : [];

            isSelectAllUnAssignedProjectDevice = filteredUnAssignedProjectDevices.length > 0 && filteredUnAssignedProjectDevices.every(a => a.isSelected && a.isCheckedChckBox);

            const updatedSelectedDevices = unAssignedProjectDevice
                ?.filter(a => a.isSelected && a.isCheckedChckBox)

            this.setState({ unAssignedProjectDeviceInfiniteList, isSelectAllUnAssignedProjectDevice, selectedDevices: updatedSelectedDevices });
        }

        searchAndFilterAssignedProject(){
            let { selectedAssignedProjectDevices,assignedProjectDeviceInfiniteList,searchAssignedDeviceText,isSelectAllAssignedProjectDevice } = this.state;

            const searchText = searchAssignedDeviceText?.toLowerCase().split(" ");

            const filteredAssignedProjectDevices = selectedAssignedProjectDevices?.filter(a => searchText.every(v => a.deviceEmpID.toLowerCase().includes(v)));

            assignedProjectDeviceInfiniteList = filteredAssignedProjectDevices ? filteredAssignedProjectDevices
                ?.slice(0, this.state.assignedProjectCurrentTake) : [];

            isSelectAllAssignedProjectDevice = filteredAssignedProjectDevices.length > 0 && filteredAssignedProjectDevices.every(a => a.isSelected && a.isCheckedChckBox);
            
            this.setState({ assignedProjectDeviceInfiniteList,isSelectAllAssignedProjectDevice });
        }

        resetAll(){
            this.setState({
                unAssignedProjectDeviceInfiniteList: [],
                assignedProjectDeviceInfiniteList:[],
                unAssignedProjectCurrentTake:Constants.DEFAULT_TAKE,
                assignedProjectCurrentTake:Constants.DEFAULT_TAKE,
                isSelectAllAssignedProjectDevice:false,
                isSelectAllUnAssignedProjectDevice:false,
            })
        }

        render() {
            const { projectsList, selectedAssignedProjectDevices, status, projectStatusOptions, searchProjectText, searchDeviceText, searchTaskText, isOpenAssignmentModal, selectedStatus, unAssignedProjectDevice, filterProjectData, selectedProjects, selectedProjectDevices, selectedProjectTasks, pagination, isViewProjectDetails, projectBasedAssignedDevices,isSaveBtnDisabled,unAssignedProjectDeviceInfiniteList,assignedProjectDeviceInfiniteList,isSelectAllUnAssignedProjectDevice,isSelectAllAssignedProjectDevice } = this.state;
            return (
                <Fragment>
                    <ProjectsComponent
                        {...{
                            project: {
                                projectsList,
                                status,
                                selectedStatus,
                                filterProjectData,
                                selectedProjectDevices,
                                selectedProjectTasks,
                                selectedProjects,
                                isOpenAssignmentModal,
                                unAssignedProjectDevice,
                                pagination,
                                isViewProjectDetails,
                                projectStatusOptions,
                                projectBasedAssignedDevices,
                                searchProjectText,
                                searchDeviceText,
                                searchTaskText,
                                selectedAssignedProjectDevices,
                                isSaveBtnDisabled,
                                unAssignedProjectDeviceInfiniteList,
                                isSelectAllUnAssignedProjectDevice,
                                assignedProjectDeviceInfiniteList,
                                isSelectAllAssignedProjectDevice
                            }
                        }}
                        renderOptions={this.renderOptions.bind(this)}
                        handleChange={this.handleChange.bind(this)}
                        editAssignDevices={this.editAssignDevices.bind(this)}
                        selectedProject={this.selectedProject.bind(this)}
                        onProjectSearch={this.onProjectSearch.bind(this)}
                        onProjectDeviceSearch={this.onProjectDeviceSearch.bind(this)}
                        onProjectTaskSearch={this.onProjectTaskSearch.bind(this)}
                        saveAssignOrUnassignProjectDevices={this.saveAssignOrUnassignProjectDevices.bind(this)}
                        assignDeviceToProjects={this.assignDeviceToProjects.bind(this)}
                        assignOrUnassignProjectDevices={this.assignOrUnassignProjectDevices.bind(this)}
                        onPageChange={this.onPageChange.bind(this)}
                        onUnAssignDeviceSearch={this.onUnAssignDeviceSearch.bind(this)}
                        onAssignedDeviceSearch={this.onAssignedDeviceSearch.bind(this)}
                        viewProjectDetail={this.viewProjectDetail.bind(this)}
                        user={this.props.user}
                        handleChgChkBoxForUnassignedDevice={this.handleChgChkBoxForUnassignedDevice.bind(this)}
                        handleChkBoxChgForUnassignedDevices={this.handleChkBoxChgForUnassignedDevices.bind(this)}
                        handleChkBoxChgForAssignedDevices={this.handleChkBoxChgForAssignedDevices.bind(this)}
                        handleChgChkBoxForAssignedDevice={this.handleChgChkBoxForAssignedDevice.bind(this)}
                        handleFormChange={this.handleFormChange.bind(this)}
                        saveProjectDetails={this.saveProjectDetails.bind(this)}
                        handleGcChange={this.handleGcChange.bind(this)}
                        fetchNext={this.fetchNext.bind(this)}
                    />
                </Fragment>
            );
        }

    }

    function mapStateToProps(state) {
        return {
            user: state.loginReducer.user
        };
    }

    function mapDispatchToProps(dispatch) {
        return bindActionCreators(
            Object.assign({},
                actions),
            dispatch);
    }

    export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Projects));

    Projects.displayName = 'Projects';